import React, {useState} from 'react';
import {
  ButtonLinkContainer,
  ButtonLinkRow,
  ButtonLinkText,
  Coupon,
  CouponInfo,
  CouponTitle,
  RemoveCouponButton,
  RemoveText,
  CouponAlert,
  CouponAlertText,
} from './styles';

import {Toast} from '../../Interface/Toast';
import {StationDTO} from '../../../dtos/StationDTO';
import {PedidoDTO} from '../../../dtos/PedidoDTO';
import {StationsModal} from '../Stations/StationsModal';

interface Props {
  pedidos: PedidoDTO;
  gnv?: boolean;
  discount: {
    code: string;
    value: number;
    placa?: string;
    membro?: string;
    stations: StationDTO[];
  };
  localidade: {
    rank: string;
    tipo: string;
    region: string;
    estado: string;
    cidade: string;
  };
  onRemoveDiscount: () => void;
}

export function CouponDiscount({
  localidade,
  discount,
  onRemoveDiscount,
}: Props) {
  const [showRemoveDiscountToast, setShowRemoveDiscountToast] = useState(false);
  const [showStationsModal, setShowStationsModal] = useState(false);

  const isBrbCode =
    discount.code === 'brb10' || discount.code === 'primeiravezbrb';

  function handleRemoveDiscount() {
    onRemoveDiscount();
    setShowRemoveDiscountToast(true);
  }

  return (
    <>
      <Coupon>
        {showRemoveDiscountToast && (
          <Toast
            type="error"
            text="Cupom de desconto removido"
            timeout={2000}
            onEnd={() => setShowRemoveDiscountToast(false)}
          />
        )}

        {isBrbCode ? (
          <CouponInfo>
            <CouponTitle>
              BRB + Baratão{' '}
              {discount.code === 'primeiravezbrb' && '(primeira compra)'}
            </CouponTitle>
            <ButtonLinkRow>
              <ButtonLinkContainer activeOpacity={1}>
                <ButtonLinkText>Aplicado automaticamente</ButtonLinkText>
              </ButtonLinkContainer>
            </ButtonLinkRow>
          </CouponInfo>
        ) : (
          <CouponInfo>
            <CouponTitle>{discount.code}</CouponTitle>
            <ButtonLinkRow>
              <ButtonLinkContainer
                onPress={() => setShowStationsModal(true)}
                activeOpacity={1}>
                <ButtonLinkText>Ver postos</ButtonLinkText>
              </ButtonLinkContainer>
            </ButtonLinkRow>
          </CouponInfo>
        )}

        {!isBrbCode && (
          <RemoveCouponButton activeOpacity={1} onPress={handleRemoveDiscount}>
            <RemoveText>Remover</RemoveText>
          </RemoveCouponButton>
        )}
      </Coupon>

      {!isBrbCode && (
        <CouponAlert>
          <CouponAlertText>
            Com a aplicação deste cupom, você só poderá abastecer em postos
            específicos.
          </CouponAlertText>
        </CouponAlert>
      )}

      <StationsModal
        showModal={showStationsModal}
        onDismiss={() => setShowStationsModal(false)}
        data={discount.stations}
        tipo={localidade.tipo}
        showRank={false}
      />
    </>
  );
}
